import React from 'react';
import { Pagination, Row, Col, Button, Form, Input } from 'antd';
import moment from 'moment';
import TableComponent from 'components/table-component';
import DatePicker from 'components/date-picker';
import { DATE_FORMAT } from 'constants/app-constants';

const layer1FormCol = {
	labelCol: {
		span: 24,
	},
	wrapperCol: {
		span: 24,
	},
};

const GRNUpdatePresentational = ({
	column,
	filteredData,
	handleTableChange,
	getStartingValue,
	getEndingValue,
	pageSize,
	intialPageSizeOptions,
	initialPageSize,
	currentPage,
	getBillingItems,
	form,
	fetchingData,
	updateGRNNumber,
	updatingData,
}) => {
	const hasValues = filteredData?.length > 0;
	return (
		<Row>
			<Col span={24} style={{ padding: 20 }}>
				<TableComponent
					scroll={{ x: 1300 }}
					loading={fetchingData}
					className="custom-table"
					style={{ width: '100%' }}
					rowKey={(record) => record._id}
					dataSource={filteredData}
					title={() => (
						<Row gutter={[10, 10]}>
							<Col span={24}>
								<h2>Goods Received Note</h2>
							</Col>
							<Col xl={16} md={16}>
								<Form
									labelAlign="left"
									name="unit-sections"
									className="required_in_right"
									form={form}
									onFinish={getBillingItems}
									{...layer1FormCol}>
									<Row gutter={[20, 0]}>
										<Col xl={8} md={8}>
											<Row>
												<Col span={24}>
													<Form.Item
														label="LR Number Search"
														name="lrNumber"
														rules={[
															{
																required: true,
																message: 'This Field is required!',
															},
														]}>
														<Input placeholder="LR No" style={{ width: '100%' }} />
													</Form.Item>
												</Col>
											</Row>
										</Col>
										<Col xl={12} md={12}>
											{hasValues && (
												<Row gutter={[10, 10]}>
													<Col span={12}>
														<Form.Item
															label="GRN No."
															name="grnNumber"
															rules={[
																{
																	required: true,
																	message: 'This Field is required!',
																},
															]}>
															<Input placeholder="GRN No." style={{ width: '100%' }} />
														</Form.Item>
													</Col>
													<Col span={12}>
														<Form.Item
															label="GRN Date"
															initialValue={moment()}
															rules={[{ required: true }]}
															name="grnDate">
															<DatePicker style={{ width: '100%' }} format={DATE_FORMAT.DD_MM_YYYY} />
														</Form.Item>
													</Col>
												</Row>
											)}
										</Col>
										<Col xl={24} md={24}>
											<Row gutter={[10, 0]}>
												<Col span={24}>
													<Row gutter={[10, 10]}>
														<Col span={8}>
															<Button
																style={{ width: '100%' }}
																loading={fetchingData}
																type="primary"
																onClick={getBillingItems}>
																Search
															</Button>
														</Col>
														<Col span={8}>
															{hasValues && !fetchingData && (
																<Button
																	style={{ width: '100%', backgroundColor: "#24b296", borderColor: "#24b296" }}
																	loading={updatingData}
																	type="primary"
																	onClick={updateGRNNumber}>
																	Update
																</Button>
															)}
														</Col>
													</Row>
												</Col>
											</Row>
										</Col>
									</Row>
								</Form>
							</Col>
						</Row>
					)}
					{...{
						columns: column,
						pagination: { current: currentPage, pageSize: pageSize, position: ['none', 'none'] },
						// pagination: { current: currentPage, pageSize: pageSize, position: ['none', 'none'] },
						// ...(!!filteredData?.length && {
						// 	footer: () => (
						// 		<Row justify="space-between">
						// 			<Col md={16}>
						// 				{!!filteredData?.length &&
						// 					`Showing ${getStartingValue()} - ${getEndingValue()} of ${filteredData?.length} Data`}
						// 			</Col>
						// 			<Col md={8}>
						// 				<div style={{ textAlign: 'right' }}>
						// 					<Pagination
						// 						pageSizeOptions={intialPageSizeOptions}
						// 						defaultPageSize={initialPageSize}
						// 						showSizeChanger={true}
						// 						total={filteredData?.length}
						// 						onChange={handleTableChange}
						// 						responsive
						// 					/>
						// 				</div>
						// 			</Col>
						// 		</Row>
						// 	),
						// }),
					}}
				/>
			</Col>
		</Row>
	);
};

export default GRNUpdatePresentational;
